import { getTasks, updateTask } from './taskService';
import { todayET } from '../utils/dueDates';

// Logging a call (or text) clears the follow-up task it was for.
// With a task: that task. Without one (contact page): the contact's open call tasks due today or earlier.
const isOpen = (t) => t && t.status !== 'completed' && t.status !== 'na';
const linkedTo = (t, contactId) => t.crmContactId === contactId;
const isCallTask = (t) => t.action === 'call' || /\bcall\b/i.test(t.title || t.name || '');
const isTextTask = (t) => t.action === 'text' || /\btext\b/i.test(t.title || t.name || '');

export const tasksClearedByLog = (tasks, contactId, type, today = todayET()) => (tasks || []).filter((t) =>
  isOpen(t) && linkedTo(t, contactId) && t.source !== 'transaction'
  && (type === 'call' ? isCallTask(t) : type === 'text' ? isTextTask(t) && !isCallTask(t) : false)
  && (!t.dueDate || String(t.dueDate).slice(0, 10) <= today));

export const clearTasksForLoggedContact = async ({ uid, contact, type, task = null }) => {
  if (!uid || !contact) return [];
  if (task && task.id) {
    if (!isOpen(task) || task.source === 'transaction') return [];
    await updateTask(uid, task.id, { status: 'completed', completedVia: `logged-${type}` });
    return [task.id];
  }
  const ids = tasksClearedByLog(await getTasks(uid), contact.id, type).map((t) => t.id);
  for (const id of ids) await updateTask(uid, id, { status: 'completed', completedVia: `logged-${type}` });
  return ids;
};
